module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "userManage"
    }
  }, [_c('b', [_vm._v("AWSアカウント同期画面")]), _c('br'), _c('br'), _vm._v(" "), _vm._m(0), _c('br'), _vm._v("\n  AWS同期 "), _c('br'), _c('br'), _vm._v("\n  同期用ユーザ："), _c('br'), _c('br'), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.awsMemberID),
      expression: "awsMemberID"
    }],
    attrs: {
      "type": "text",
      "placeholder": "ユーザＩＤ"
    },
    domProps: {
      "value": (_vm.awsMemberID)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.awsMemberID = $event.target.value
      }
    }
  }), _c('br'), _c('br'), _vm._v("\n  同期用パスワード："), _c('br'), _c('br'), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.awsPassword),
      expression: "awsPassword"
    }],
    attrs: {
      "type": "password",
      "placeholder": "パスワード"
    },
    domProps: {
      "value": (_vm.awsPassword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.awsPassword = $event.target.value
      }
    }
  }), _c('br'), _c('br'), _vm._v(" "), _c('button', {
    staticClass: "btn-mid",
    staticStyle: {
      "width": "250px"
    },
    on: {
      "click": _vm.syncAws
    }
  }, [_vm._v("AWS同期")]), _vm._v(" \n  "), _c('button', {
    staticClass: "btn-mid",
    staticStyle: {
      "width": "250px"
    },
    on: {
      "click": function($event) {
        return _vm.$router.back(-1);
      }
    }
  }, [_vm._v("キャンセル")]), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "bootstrap-table fixed-table-container",
    staticStyle: {
      "margin-bottom": "10px",
      "width": "100%"
    }
  }, [_c('table', {
    staticClass: "table table-striped",
    attrs: {
      "id": "rptHeader"
    }
  }, [_vm._m(1), _vm._v(" "), _c('tbody', _vm._l((_vm.syncResultMessages), function(row, index) {
    return _c('tr', {
      key: 'row' + index
    }, [_c('td', [_vm._v(_vm._s(row))])])
  }), 0)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "table icon"
  }, [_c('tr', [_c('td', [_vm._v("AWSアカウント同期用画面です。")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('td', [_vm._v("同期結果:")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-715bdd9e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/module/syncAWS.vue
// module id = 130
// module chunks = 2